
(function ($) {
  $(document).ready(function () {

    //scroll from header to the first section on front page
    $('a[href*=\\#]').on('click', function(e) {
      // alert("INFO");
      e.preventDefault();
      $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top - 76}, 700, 'linear');
    });

  });
})(jQuery);
